import {MRT_Row} from 'material-react-table';
import React from 'react';
import {Avatar, Label} from '@lightricks/react-design-system';
import {type BrandedContentAdsPartnership} from '@/types/brandedContentAdsPartnership';
import styles from './CreatorCell.module.scss';

function CreatorCell({row}: {row: MRT_Row<BrandedContentAdsPartnership>}) {
  const partnership = row.original;
  const displayName = partnership?.profile?.displayName || 'Unknown Creator';
  const imageUrl = partnership?.profile?.imageUrl;

  return (
    <div className={styles.container}>
      <Avatar
        size="md"
        type={imageUrl ? 'picture' : 'placeholder'}
        src={imageUrl}
        className={styles.avatar}
      />
      <Label size="sm">{displayName}</Label>
    </div>
  );
}

export default CreatorCell;
